import Cookies from "js-cookie";
import { createContext, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import filterRoutesByAccess from "../Utils/filterRoutesByAccess";
import { useAppSetting } from "./appSettingContext";

const userCookieName = "wafaa-user-data";

const UserContext = createContext();

export function useAuth() {
    return useContext(UserContext);
}

export function UserProvider({ children }) {
    const [authUser, setAuthUser] = useState(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const { clientAccess } = useAppSetting();
    const location = useLocation();
    const navigate = useNavigate();

    const authGuardRoutes = ["/home", "/offers", "/history", "/transactions", "/digital-receipt", "/profile", "/my-profile"];
    const nonAuthGuardRoutes = ["/", "/login", "/join"];

    const { filteredRoutes } = filterRoutesByAccess(clientAccess);

    useEffect(() => {
        const userCookie = Cookies.get(userCookieName);
        const authRouteMatch = authGuardRoutes.some((route) => location.pathname.includes(route));
        const nonAuthRouteMatch = nonAuthGuardRoutes.some((route) => location.pathname.includes(route));

        if (!userCookie) {
            if (authRouteMatch) {
                navigate("/", { replace: true });
            }
            return;
        }

        try {
            const userData = JSON.parse(userCookie);
            if (!userData || typeof userData !== "object") {
                throw new Error("Invalid user data format");
            }

            setAuthUser(userData);
            setIsLoggedIn(true);

            if (nonAuthRouteMatch) {
                // Use the old behavior of redirecting to '/home' if no filtered routes
                const redirectPath = filteredRoutes?.length > 0 ? filteredRoutes[0]?.path : "/home";

                if (redirectPath && !nonAuthGuardRoutes.includes(redirectPath)) {
                    navigate(redirectPath, { replace: true });
                }
            }
        } catch (error) {
            console.error("Error processing user cookie:", error);
            Cookies.remove(userCookieName, { path: "/" });
            navigate("/login", { state: { from: location }, replace: true });
        }
    }, []);

    const authenticationState = {
        authUser,
        setAuthUser,
        isLoggedIn,
        setIsLoggedIn,
    };

    return <UserContext.Provider value={authenticationState}>{children}</UserContext.Provider>;
}
